import { ref, unref, computed } from "vue";
import { LocationGroup, LocationEntry } from '@Components/LocationPicker/Types/Data';
import { FilterSelectionLocationEntry } from "@Types/FilterSelections";

/**
 * obsolete, these are helpers for the old seperate fetches. in the 2023 version,
 * all locations are loaded client side on page load (server side cache)
 * @returns
 */
export const fetchLocationData = () => {

    const fetchCountriesEndpoint = "/Fetch/FetchCountries";
    const fetchRegionsEndpoint = "/Fetch/FetchRegions?countryId=";
    const fetchCitiesForCountryEndpoint = "/Fetch/FetchCitiesForCountries?countryId=";
    const fetchCitiesForRegionEndpoint = "/Fetch/FetchCitiesForRegion?regionId=";


    // Variables used for fetch state and errors
    const isLoading = ref(false);
    const hasLoadError = ref(false);
    const errorMessages = ref<Array<string>>([]);

    const fetchedCountryList = ref<Array<LocationEntry>>([]);
    const fetchedRegionList = ref<Array<LocationEntry>>([]);
    const fetchedCityList = ref<Array<LocationEntry>>([]);

    const fetchCountries = async () => {

        isLoading.value = true;

        fetchedCountryList.value = [];

        const url = new URL(fetchCountriesEndpoint, window.location.href);
       
        const response = await fetch(url.toString(), {

            method: "Get",
            headers: { 'Content-Type': 'application/json' },
            redirect: "error"

        });

        if (response.ok) {

            fetchedCountryList.value = await response.json() as Array<LocationEntry>;

        } else {

            alert('Something went wrong, please try again');
        }

        isLoading.value = false;
    }

    const fetchRegions = async (countryId: number) => {

        // reset fetched list
        isLoading.value = true;
        fetchedRegionList.value = [];

      
        const url = new URL(fetchRegionsEndpoint + countryId, window.location.href);
       
        const response = await fetch(url.toString(), {

            method: "Get",
            headers: { 'Content-Type': 'application/json' },
            redirect: "error"

        });

        if (response.ok) {

            fetchedRegionList.value = await response.json() as Array<LocationEntry>;

        } else {

            alert('Something went wrong, please try again');
        }

        isLoading.value = false;

    };

    const fetchCitiesForCountry = async (countryId: number) => {

        // reset fetched list
      
        isLoading.value = true;
        fetchedCityList.value = [];


        const url = new URL(fetchCitiesForCountryEndpoint + countryId, window.location.href);

        const response = await fetch(url.toString(), {

            method: "Get",
            headers: { 'Content-Type': 'application/json' },
            redirect: "error"

        });

        if (response.ok) {

            fetchedCityList.value = await response.json() as Array<LocationEntry>;

        } else {

            alert('Something went wrong, please try again');
        }
        isLoading.value = false;
    };

    const fetchCitiesForRegion = async (regionId: number) => {

        // reset fetched list
        isLoading.value = true;
        fetchedCityList.value = [];


        const url = new URL(fetchCitiesForRegionEndpoint + regionId, window.location.href);

        const response = await fetch(url.toString(), {

            method: "Get",
            headers: { 'Content-Type': 'application/json' },
            redirect: "error"

        });

        if (response.ok) {

            fetchedCityList.value = await response.json() as Array<LocationEntry>;

        } else {

            alert('Something went wrong, please try again');
        }
        isLoading.value = false;
    };

    return {

        fetchCountries,
        fetchRegions,
        fetchCitiesForCountry,
        fetchCitiesForRegion,

        fetchedCountryList,
        fetchedRegionList,
        fetchedCityList,

        isLoading,
        hasLoadError,
        errorMessages,

    };
};

export function getSelectedLocationName(location: FilterSelectionLocationEntry) {
    let countryName = "";
    let regionName = "";
    let cityName = "";


    if (location != undefined && location.countryName != undefined) {
        countryName = location.countryName;
    }

    if (location != undefined && location.regionName != undefined) {
        regionName = location.regionName;
    }

    if (location != undefined && location.cityName != undefined) {
        cityName = location.cityName;
    }
    return { countryName, regionName, cityName };
    
};

